export const KNOWLEDGE_ENDPOINTS = {
  /** Unité de faits d'un objectif (404 = pas d'unité extraite). */
  GET: (objectiveId: string) => `/v1/objectives/${objectiveId}/knowledge`,
  /** Bascule actif/désactivé + note sur un fait (admin). */
  PATCH_FACT: (objectiveId: string, factId: string) =>
    `/v1/objectives/${objectiveId}/knowledge/facts/${encodeURIComponent(factId)}`,
  /** Ré-extraction synchrone des unités de tous les objectifs d'un document. */
  EXTRACT: (documentId: string) => `/v1/documents/${documentId}/knowledge`,
  /** Backfill du parc (202, en arrière-plan ; 409 si un run tourne déjà). */
  RUN_BULK: "/v1/knowledge/run",
  /** État du run du parc en cours (même chemin, en lecture). */
  RUN_STATUS: "/v1/knowledge/run",
  /** Signalements « exercice faux » agrégés par fait, remontés par tc_learn. */
  REPORTS: "/v1/knowledge/reports",
} as const;
